import React, { useEffect, useState } from 'react'
import ReactBeforeAfterSlider from 'react-before-after-slider'

import { isBrowser } from '../utils'

const BeforeAfterSlider = ({ before, after, ratio, ...props }) => {
  const [size, setSize] = useState({ width: 200, height: 200 * ratio })
  useEffect(() => {
    setSize({
      width: window.innerWidth * 0.61,
      height: window.innerWidth * 0.61 * ratio,
    })
  }, [])

  return isBrowser ? (
    <ReactBeforeAfterSlider
      before={before}
      after={after}
      {...size}
      {...props}
    />
  ) : (
    <div>
      <img src={before} alt="Before" />
      <img src={after} alt="After" />
    </div>
  )
}

export default BeforeAfterSlider
